import {FC} from "react";

export const SpeedLineIcon: FC = () => {
    return (
        <svg width="24" height="2" viewBox="0 0 24 2" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="12" height="1" transform="translate(0 0.5)" fill="#909090"/>
            <rect width="5" height="1" transform="translate(14 0.5)" fill="#909090"/>
            <rect width="3" height="1" transform="translate(21 0.5)" fill="#909090"/>
        </svg>
    )
}import {FC} from "react";

export const SpeedLineIcon: FC = () => {
    return (
        <svg width="24" height="2" viewBox="0 0 24 2" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="12" height="1" transform="translate(0 0.5)" fill="#909090"/>
            <rect width="5" height="1" transform="translate(14 0.5)" fill="#909090"/>
            <rect width="3" height="1" transform="translate(21 0.5)" fill="#909090"/>
        </svg>
    )
}